<script setup lang="ts">
import { useDisplay } from "vuetify";
const { mdAndUp } = useDisplay();
const route = useRoute();
const config = useRuntimeConfig();
import { usePlaceStore } from "@/stores/place";
import { GoogleMap, AdvancedMarker } from "vue3-google-map";
import { isBrowser } from "mobile-device-detect";

const placeStore = usePlaceStore();
await placeStore.fetch(route.params.id);
const { place } = placeStore;
const center = { lat: place.lat, lng: place.lng };
const markerOptions = { position: center, title: "DOGFUL" };
const pinOptions = { background: "#FBBC04" };

const { key } = config.public.gmap;

function onClickLaunchAppButton() {
  if (isBrowser) {
    window.open(
      `https://maps.google.com/maps?daddr=${place.lat},${place.lng}&z=16`,
    );
  } else {
    window.location = `comgooglemaps://?daddr=${place.lat},${place.lng}&z=16`;
  }
}

const tab = ref(null);
const tag_txt = place.features.map((f) => f.name).join("、");

useHead({
  title: `${place.name} | ドッグフル`,
  meta: [
    { name: "description", content: `${place.catch}。${tag_txt}` },
    { name: "og:title", content: `${place.name} | ドッグフル` },
    { name: "og:description", content: `${place.catch}` },
    { name: "twitter:title", content: `${place.name} | ドッグフル` },
    { name: "thumbnail", content: place.image1.url },
    { name: "og:image", content: place.image1.url },
    { name: "twitter:image", content: place.image1.url },
  ],
});

definePageMeta({
  layout: "place",
});
</script>

<template lang="pug">
v-container(class="pa-md-0").place
  v-carousel(
    height="300"
    hide-delimiter-background
    delimiter-icon="mdi-square"
  )
    v-carousel-item(
      :src="place.image1.url"
      cover
    )
    v-carousel-item(
      :src="place.image2.url"
      cover
      v-if="place.image2.url"
    )
    v-carousel-item(
      :src="place.image3.url"
      cover
      v-if="place.image3.url"
    )
  v-row(no-gutters)
    v-col(cols="12" md="10")
      h1 {{place.name}}
      span(class="text-subtitle-2 text-grey-darken-2") {{place.fullAddress}}
      div(class="ma-0 text-left")
        v-chip(
          :key="feature.slug"
          v-for="feature in place.features"
          class="ma-1"
          size="small"
        ) {{feature.name}}
    v-col(
      cols="0"
      sm="0"
      md="2"
      v-if="mdAndUp && place.aff_url"
      align-self="center"
    )
      v-btn(
        size="large"
        class="book-btn"
        color="warning"
        :href="place.aff_url"
        target="_blank"
      )
        v-icon mdi-calendar-month
        b 予約する

  v-tabs(
    v-model="tab"
    bg-color="white"
    slider-color="teal-lighten-3"
    :show-arrows="true"
    class="my-2"
  )
    v-tab(:value=1): b 施設情報
    v-tab(:value=2): b(class="text-grey-lighten-1") 写真（開発中）
    v-tab(:value=3): b(class="text-grey-lighten-1") 口コミ（開発中）

  v-tabs-window(v-model="tab")
    v-tabs-window-item(:value=1)
      v-sheet(
        width="100%"
        rounded
        :class="`catch ${place.placeType} py-2 my-2 px-2`"
      ): b {{place.catch}}

      v-container.content(v-html="place.parsed_content")


      h2 施設情報
      v-row(class="")
        v-col(cols="12" md="6" class="text-center" )
          v-img(
            :src="place.image1.url"
            height="auto"
            class="py-2"
          )
          GoogleMap(
            :api-key="key"
            class="map py-2"
            :center="center" :zoom="13"
            mapId="place-map"
            style="width: 100%; height: 250px;"
          )
            AdvancedMarker(
              :options="markerOptions"
              :pin-options="pinOptions"
            )
          v-btn.launch-app(
            color="primary"
            @click="onClickLaunchAppButton"
          ): b Google Mapで見る



        v-col(cols="12" md="6")
          v-table
            tbody
              tr
                td(class="font-weight-bold") 施設名
                td {{place.name}}
              tr
                td(class="font-weight-bold") 住所
                td {{place.fullAddress}}
              tr
                td(class="font-weight-bold") TEL
                td: a(:href="`tel:${place.tel}`") {{ place.tel }}
              tr
                td(class="font-weight-bold") HP
                td: a(:href="place.url" target="_blank") {{ place.url }}
              tr
                td(class="font-weight-bold") 営業時間
                td {{place.open_hour_free_text}}

    v-tabs-window-item(:value=2)
      v-row(justify='center')
        v-col(cols="auto")
          v-container(height="100px")
            b 開発中です。
    v-tabs-window-item(:value=3)
      v-row(justify='center')
        v-col(cols="auto")
          v-container(height="100px")
            b 開発中です。
CategoryList
</template>

<style lang="scss" scoped>
.place {
  width: 700px;
  margin-bottom: 50px;

  h1 {
    font-size: 1.4rem;
  }

  h2 {
    font-size: 1.1rem;
  }

  .book-btn {
    color: white !important;
  }

  span.published-at {
    color: #707070;
  }
  .catch {
    vertical-align: middle;

    &.dog-run {
      background-color: #2f8859;
      color: white;
    }

    &.dog-cafe {
      background-color: #f4774a;
      color: white;
    }

    &.dog-hotel {
      background-color: #51a3dc;
      color: white;
    }

    &.pet-salon {
      background-color: #f08e9f;
      color: white;
    }

    &.campsite {
      background-color: #f6e75d; // yellow-lighten-3
      color: #212121; // grey-darken-4
    }
  }
  img {
    width: 100%;
    height: 400px;
    object-fit: cover;
  }

  p.summary,
  div.content {
    line-height: 2rem;
    text-align: left;
  }

  div.content {
    padding: 10px;
    text-align: left;
    :deep(h3) {
      text-align: left;
      margin: 10px 0px;
      font-size: 1rem;
    }

    :deep(p) {
      font-size: 0.9rem;
    }
    :deep(strong) {
      background: linear-gradient(transparent 57%, #fdf50d 0);
    }
    :deep(.a2a_kit) {
      text-align: center;
    }

    :deep(img):not([height="1"]) {
      width: 100%;
      height: 400px;
      object-fit: cover;
    }
    :deep(table) {
      border-collapse: collapse;
      tr {
        border-bottom: 1px solid #e7e7e7;
      }
      td {
        padding: 5px;
      }
    }
  }
}

.news {
  line-height: 2rem;
}

.v-slide-group:nth-of-type(4) {
  display: none;
}

@media (max-width: 576px) {
  .v-container {
    width: 100%;
    img {
      height: 200px;
    }

    div.content {
    }
  }
}
</style>
